<template>
	<div>
		<h3>Videos</h3>
		<ul>
			<li v-for="video in videos" :key="video.id">
				{{video.title}}
			</li>
		</ul>
	</div>
</template>
<script>
	import App from '@/App'

	export default {
		data: () => {
			return {
				url: App.data().url,
				videos: []
			}
		},
		mounted(){
			App.methods.getData(this.url.videos, (data) => {
				if(data){
					this.videos = data;
					console.log(this.videos)
				}
			});
		}
	}
</script>